import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';

const NavigationMainItem = inject("stores") (
    observer (
        class NavigationMainItem extends Component {
            constructor(props) {
                super(props);
                this.props = props;

                this.storeUi = this.props.stores.storeUi;
            }

            render() {
                return (
                    <li className="navigation--main__listitem">    
                        <Link 
                            to = {this.props.nav_item.path}
                        >
                            {this.props.nav_item.display_value}   
                        </Link>         
                    </li>
                );
            }
        }
    )
)

const NavigationMain = inject("stores") (
    observer (
        class NavigationMain extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.storeUi = this.props.stores.storeUi;
            }

            handleNavMobile = (e) => {
                this.storeUi.setNavMobile();
            }

            render() {
                return (
                    <React.Fragment>
                        <ul className="navigation--main__list">    
                        {this.storeUi.main_nav.map((nav_item) => (
                            <NavigationMainItem
                                nav_item = {nav_item}
                            />
                        ))}               
                        </ul>
                        {/* <span className="navigation--main__mobile-trigger" onClick={(e)=>this.handleNavMobile(e)}>mobile</span> */}
                    </React.Fragment>
                );
            }
        }
    )
)

export default NavigationMain;
